import { render } from "./question.html?vue&type=template&id=1f31e6ce"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import "./question.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script